module.exports = __webpack_public_path__ + "img/elle.1a105131.png";